// 未知網址（SPEC #vms-web-220「未知網址」；VMS UX 評審第三輪 B3-18）：選單沒有、轉址表也沒有的網址顯示 404，
// 不再顯示總覽冒充；有明顯對應的（/account、/user、/profile → 我的帳號）直接轉過去。舊網址的轉址在殼層（Shell）先處理。
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { usePageSubject } from '../../lib/pageTitle';

const ALIASES: Record<string, string> = { '/account': '/settings', '/user': '/settings', '/profile': '/settings', '/me': '/settings' };

/** 未知網址 → 對應的頁（沒有 = null）。 */
export function aliasOf(pathname: string): string | null {
  const p = pathname.replace(/\/+$/, '') || '/';
  return ALIASES[p] ?? null;
}

export function NotFound() {
  const { t } = useTranslation();
  const loc = useLocation();
  usePageSubject(t('notfound.title'));
  const to = aliasOf(loc.pathname);
  if (to) return <Navigate to={to + loc.search + loc.hash} replace />;
  return (
    <section data-testid="not-found">
      <h1 className="page-title">{t('notfound.title')}</h1>
      <p>{t('notfound.body', { path: loc.pathname })}</p>
      <Link className="btn btn-primary" to="/">
        {t('notfound.home')}
      </Link>
    </section>
  );
}
